/**
 * @generated SignedSource<<0debdb45a4cfc1f544816d058f22dbc1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "accountId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "offset"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pAccountId"
},
v4 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v5 = {
  "kind": "Variable",
  "name": "offset",
  "variableName": "offset"
},
v6 = {
  "kind": "Literal",
  "name": "orderBy",
  "value": "PROJECT_START_DESC"
},
v7 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "resellerAccountId",
        "variableName": "pAccountId"
      }
    ],
    "kind": "ObjectValue",
    "name": "condition"
  },
  (v4/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectId",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectName",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectStart",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectStatus",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountId",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountName",
  "storageKey": null
},
v15 = [
  (v13/*: any*/),
  (v14/*: any*/)
],
v16 = [
  (v8/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "ProjectT",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountT",
        "kind": "LinkedField",
        "name": "accountTByResellerAccountId",
        "plural": false,
        "selections": (v15/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountT",
        "kind": "LinkedField",
        "name": "accountTByCustomerAccountId",
        "plural": false,
        "selections": (v15/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v17 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "customerAccountId",
        "variableName": "accountId"
      }
    ],
    "kind": "ObjectValue",
    "name": "condition"
  },
  (v4/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/)
],
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
},
v19 = [
  (v13/*: any*/),
  (v14/*: any*/),
  (v18/*: any*/)
],
v20 = [
  (v8/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "ProjectT",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountT",
        "kind": "LinkedField",
        "name": "accountTByResellerAccountId",
        "plural": false,
        "selections": (v19/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountT",
        "kind": "LinkedField",
        "name": "accountTByCustomerAccountId",
        "plural": false,
        "selections": (v19/*: any*/),
        "storageKey": null
      },
      (v18/*: any*/)
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProjectsQuery",
    "selections": [
      {
        "alias": "projectsForProvisioner",
        "args": (v7/*: any*/),
        "concreteType": "ProjectTsConnection",
        "kind": "LinkedField",
        "name": "allProjectTs",
        "plural": false,
        "selections": (v16/*: any*/),
        "storageKey": null
      },
      {
        "alias": "projectsForCustomer",
        "args": (v17/*: any*/),
        "concreteType": "ProjectTsConnection",
        "kind": "LinkedField",
        "name": "allProjectTs",
        "plural": false,
        "selections": (v16/*: any*/),
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "ProjectsQuery",
    "selections": [
      {
        "alias": "projectsForProvisioner",
        "args": (v7/*: any*/),
        "concreteType": "ProjectTsConnection",
        "kind": "LinkedField",
        "name": "allProjectTs",
        "plural": false,
        "selections": (v20/*: any*/),
        "storageKey": null
      },
      {
        "alias": "projectsForCustomer",
        "args": (v17/*: any*/),
        "concreteType": "ProjectTsConnection",
        "kind": "LinkedField",
        "name": "allProjectTs",
        "plural": false,
        "selections": (v20/*: any*/),
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "fa5934bf1eb31eda6b380e0bde6199d2",
    "id": null,
    "metadata": {},
    "name": "ProjectsQuery",
    "operationKind": "query",
    "text": "query ProjectsQuery(\n  $accountId: UUID!\n  $pAccountId: UUID!\n  $first: Int\n  $offset: Int\n) {\n  projectsForProvisioner: allProjectTs(condition: {resellerAccountId: $pAccountId}, first: $first, offset: $offset, orderBy: PROJECT_START_DESC) {\n    totalCount\n    nodes {\n      projectId\n      projectName\n      projectStart\n      projectStatus\n      accountTByResellerAccountId {\n        accountId\n        accountName\n        nodeId\n      }\n      accountTByCustomerAccountId {\n        accountId\n        accountName\n        nodeId\n      }\n      nodeId\n    }\n  }\n  projectsForCustomer: allProjectTs(condition: {customerAccountId: $accountId}, first: $first, offset: $offset, orderBy: PROJECT_START_DESC) {\n    totalCount\n    nodes {\n      projectId\n      projectName\n      projectStart\n      projectStatus\n      accountTByResellerAccountId {\n        accountId\n        accountName\n        nodeId\n      }\n      accountTByCustomerAccountId {\n        accountId\n        accountName\n        nodeId\n      }\n      nodeId\n    }\n  }\n}\n"
  }
};
})();

node.hash = "1a8ab71a56e7a7fd7a45c00472e36f44";

module.exports = node;
